export const OpenChangePlanModal = (coupon) => {
  return { type: "OPEN_CHANGE_PLAN_MODAL", coupon: coupon };
};
export const CloseChangePlanModal = () => {
  return { type: "CLOSE_CHANGE_PLAN_MODAL" };
};
